module.exports = __webpack_public_path__ + "static/media/Group 421@2x.87c0804c.png";